class FindMyZone extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.error = this.querySelector('[data-result-error]');
    this.zipCode = this.querySelector('[data-zip-code]');
    this.resultBox = this.querySelector('[data-result-box]');
    this.resultZip = this.querySelector('[data-result-zip]');
    this.resultZone = this.querySelector('[data-result-zone]');
    this.resultCity = this.querySelector('[data-result-city]');
    this.resultState = this.querySelector('[data-result-state]');
    this.zoneResultBox = this.querySelector('[data-zone-results]');
    this.zipCodes = [];
    if (
      !this.button ||
      !this.error ||
      !this.zipCode ||
      !this.resultBox ||
      !this.resultZip ||
      !this.resultZone ||
      !this.resultCity ||
      !this.resultState
    ) {
      console.info('Required markup missing.');
      return;
    }
    this.button.addEventListener('click', this.findUSDA.bind(this));
  }

  findUSDA = () => {
    if (this.zipCodes.length) {
      this.searchData();
      return;
    }
    const response = fetch('//cdn.shopify.com/s/files/1/0061/1391/9089/files/usda_zone.csv')
      .then((response) => response.text())
      .then((data) => {
        const rows = data.split('\n');
        for (var i = 1, row; (row = rows[i]); i++) {
          const details = row.split(',');
          const detail = {
            zipCode: details[0],
            zone: details[1],
            city: details[2],
            state: details[3]
          };
          this.zipCodes.push(detail);
        }
        this.searchData();
      })
      .catch((err) => console.log(err));
  };

  searchData = () => {
    if (!this.zipCodes.length) return;
    const matchingZip = this.zipCodes.find((value, index) => {
      return value.zipCode === this.zipCode.value;
    });
    if (matchingZip) {
      this.error.classList.add('hidden');
      this.resultZip.textContent = matchingZip.zipCode;
      this.resultZone.textContent = matchingZip.zone;
      this.resultCity.textContent = matchingZip.city;
      this.resultState.textContent = matchingZip.state;
      this.zoneResultBox.setAttribute('class', '');
      this.zoneResultBox.classList.add('_' + matchingZip.zone);
      this.resultBox.classList.remove('hidden');
    } else {
      this.resultBox.classList.add('hidden');
      this.error.classList.remove('hidden');
    }
  };
}

customElements.define('find-my-zone', FindMyZone);
